module.exports = __webpack_public_path__ + "img/contact.69f1c886.png";